import React from "react";
import ReactDOM from "react-dom";
//import registerServiceWorker from './registerServiceWorker';
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import store, { history } from "./store";
import App from "./containers/app";
import { MuiThemeProvider, createMuiTheme } from "material-ui/styles";
import orange from "material-ui/colors/orange";
import preload from "./utilities/preloader";
import DashboardLogo from "./images/dashboard-logo.svg";
import FuelLogo from "./images/fuel-logo.png";
import GasLogo from "./images/gas-logo.png";
import DrivingLogo from "./images/driving-logo.png";
import TempLogo from "./images/temp-logo.png";
import ScanLogo from "./images/scan-logo.png";

import "./index.css";
import "./ReactTableOverrides.css";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#FF9100",
      contrastText: "#fff"
      //main: orange[800]
    }
  }
});

window.setTimeout(() => {
  preload([DashboardLogo, FuelLogo, GasLogo, DrivingLogo, TempLogo, ScanLogo]);
}, 2000);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <MuiThemeProvider theme={theme}>
        <App />
      </MuiThemeProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js